var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.obj.keep_hidden && this.$store.state.current_org.id)?_c('div',{class:_vm.inline ? ["columns", "large-24"] : []},[_c('div',{staticClass:"future-message"},[_vm._v(_vm._s(_vm.t('app.registration.valid_today.obj_is_hidden', {name: _vm.t(`app.registration.valid_today.${_vm.i18n_klass}`)})))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }